module.exports = __webpack_public_path__ + "assets/img/Main.5f95c3bc.svg";